import { Facet } from '../models/Facet';

export const documentTemplateFacet = new Facet<{
  templateUrl?: string;
}>('documentTemplate');
